import { ApolloQueryResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface PostsQueryObject {
  posts: {
    page_info: {
      current_page: boolean
      page_size: boolean
      total_pages: boolean
      [key: string]: any
    }
    total_count: boolean
    items: {
      title: boolean
      full_content: boolean
      list_image: boolean
      post_id: boolean
      post_image: boolean
      post_image_alt: boolean
      posted_by: boolean
      published_at: boolean
      short_content: boolean
      meta_description: boolean
      meta_title: boolean
      url_key: boolean
      tags: {
        name: boolean
        tag_id: boolean
        tag_url_key: boolean
        [key: string]: any
      }
      next: {
        post_id: boolean
        url_key: boolean
        title: boolean
        post_image: boolean
        [key: string]: any
      }
      prev: {
        post_id: boolean
        url_key: boolean
        title: boolean
        post_image: boolean
        [key: string]: any
      }
      [key: string]: any
    }
    [key: string]: any
  }
}

export const postsQueryObject: PostsQueryObject = {
  posts: {
    page_info: {
      current_page: true,
      page_size: true,
      total_pages: true
    },
    total_count: true,
    items: {
      title: true,
      full_content: true,
      list_image: true,
      post_id: true,
      post_image: true,
      post_image_alt: true,
      posted_by: true,
      published_at: true,
      short_content: true,
      meta_description: true,
      meta_title: true,
      url_key: true,
      tags: {
        name: true,
        tag_id: true,
        tag_url_key: true
      },
      next: {
        post_id: true,
        url_key: true,
        title: true,
        post_image: true
      },
      prev: {
        post_id: true,
        url_key: true,
        title: true,
        post_image: true
      }
    }
  }
}

interface PostsQueryInput {
  filters?: Record<string, any>
  currentPage?: number
  sort?: string
  direction?: string
}

export type PostsQuery = (input: PostsQueryInput) => Promise<ApolloQueryResult<any>>

export const createPostsQuery = ({ getQueries }: ServiceDependencies): PostsQuery => async ({ filters = {}, currentPage, sort, direction }) => {
  const query = getQueries().postsQuery

  const filter: any = {}
  for (const key in filters) {
    const value = filters[key]
    if (value) {
      filter[key] = value
    }
  }

  if (Object.keys(filter).length) {
    query.posts.__args = {
      filter,
      currentPage: currentPage ?? 1
    }
  }

  if (sort) query.posts.__args.sort = sort
  if (direction) query.posts.__args.direction = direction

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`
  })
}
